import "./index.scss";
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';

/**
 * Component: ProductSlider
 */
export function ProductSlider() {
  console.log("ProductSlider mounted.");

  /**
   * Content carousel (slider) with extensive options to control behaviour and appearance
   * @requires https://swiperjs.com/
   */

  new Swiper('.swiper-products', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,

    modules: [Navigation, Pagination],
  
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },
  
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      "500": {
        "slidesPerView": 3
      },
      "768": {
        "slidesPerView": 4
      },
      "1100": {
        "slidesPerView": 5
      }
    }    
  });   
}
